/* @flow */
export default {
    text: '',
    copyright: '© 2008 - 2018 Catavolt, Inc. All Rights Reserved.',
};
